import request from "../utils/request";


const schemeApi = {
  SchemeList: 'template/public',
  Scheme: "template",
  SchemeChild: "template/period",
  Activity: "activity",
  Schedule: "schedule",
  ScheduleAll: "schedule/all",
  Patient: "template_patient",
  PatientHistory: "template_patient/history",
  PatientPauseMedicine: "template_patient/pause/medicine",
  PatientResumeMedicine: "template_patient/resume/medicine",
  PatientCalendar: "schedule/calendar",
  SchemeState: "template_patient/state",
  PatientInfo: "/patientInfo",
  SchemeCopy: '/template_copy/copy',
  SchemeCopyTab: '/template_copy/tab',
  SchemeCopyDept: '/template_copy/dept',
  SchemeCopyList: '/template_copy/list'
}

export function getSchemeListApi({ name, page, size, is_draft}) {
  return request({
    url: schemeApi.SchemeList,
    method: "get",
    params: {
      page, size, is_draft, name
    },

  })
}

export function publicSchemeApi(id) {
  return request({
    url: schemeApi.Scheme + '/' + id,
    method: "post",

  })
}
export function assignSchemeApi(parameter) {
  return request({
    url: schemeApi.Patient,
    method: "post",
    data: parameter,

  });
}

export function getSchemeDetailApi({id, patient_id}) {
  return request({
    url: schemeApi.Scheme + '/' + id,
    method: "get",
    params: {
      patient_id
    },

  })
}

export function addSchemeApi(parameter) {
  return request({
    url: schemeApi.Scheme,
    method: "post",
    data: parameter,

  });
}

export function editSchemeBasicApi(parameter) {
  return request({
    url: schemeApi.Scheme,
    method: "put",
    data: parameter,

  });
}
export function addActivityApi(parameter) {
  return request({
    url: schemeApi.Activity,
    method: "post",
    data: parameter,

  })
}
export function deleteActivityApi(parameter) {
  return request({
    url: schemeApi.Activity,
    method: "delete",
    data: parameter,

  })
}

export function editActivityApi(id, parameter) {
  return request({
    url: schemeApi.Activity + '/' + id,
    method: "put",
    data: parameter,

  })
}

// 查询方案计划（360视图+预览已保存方案）
// template_id, patient_id, event_type=1
export function getPatientActivityListApi(parameter) {
  return request({
    url: schemeApi.Schedule,
    method: "get",
    params: parameter,
    headers: {
      role: "doctor"
    }
  })
}

// 查询所有方案计划（360视图+预览已保存方案）
export function getPatientSchemeListApi(parameter) {
  return request({
    url: schemeApi.ScheduleAll,
    method: "get",
    params: parameter,
    headers: {
      role: "doctor"
    }
  })
}

export function getPatientCalendarApi(parameter) {
  return request({
    url: schemeApi.PatientCalendar,
    method: "get",
    params: parameter,
    headers: {
      role: "doctor"
    }
  })
}
// 获取所有治疗方案
export function getPatientHistorySchemeListApi(parameter) {
  return request({
    url: schemeApi.PatientHistory,
    method: "get",
    params: parameter,
  })
}
// 新增子阶段
export function addSchemeChildBasicApi(data) {
  return request({
    url: schemeApi.SchemeChild,
    method: "post",
    data,
  })
}
// 删除子阶段
export function deleteSchemeChildApi(data) {
  return request({
    url: schemeApi.SchemeChild,
    method: "delete",
    data,
  })
}
// 暂停所有用药
export function pausePatientMedicineApi(data) {
  return request({
    url: schemeApi.PatientPauseMedicine,
    method: "put",
    data
  })
}
export function resumePatientMedicineApi(data) {
  return request({
    url: schemeApi.PatientResumeMedicine,
    method: "put",
    data
  })
}
// 打卡
export function clockPatientApi(id, parameter, data) {
  return request({
    url: schemeApi.Schedule + '/' + id,
    method: "put",
    params: parameter,
    data
  })
}
// 改变状态
export function changeTemplateStateApi(data) {
  return request({
    url: schemeApi.SchemeState,
    method: "patch",
    data
  })
}

export function getPatientInfoApi(parameter) {
  return request({
    url: schemeApi.PatientInfo,
    method: "get",
    params: parameter
  })
}
export function getSchemeCopyTabApi() {
  return request({
    url: schemeApi.SchemeCopyTab,
    method: 'get',
  })
}

export function getSchemeCopyDeptApi(baseUrl, headers) {
  return request({
    url: baseUrl || schemeApi.SchemeCopyDept,
    method: 'get',
    withoutHeaders: true,
    headers
  })
}
export function getSchemeCopyListApi(baseUrl, parameter, headers) {
  return request({
    url: baseUrl || schemeApi.SchemeCopyList,
    method: 'get',
    params: parameter,
    withoutHeaders: true,
    headers
  })
}
export function copySchemeApi(parameter, data) {
  return request({
    url: schemeApi.SchemeCopy,
    method: 'post',
    params: parameter,
    data
  })
}
